import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlane = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8349 10.9514C19.9932 10.5058 19.9613 10.0876 19.7637 10.0174C19.5661 9.9472 19.2775 10.2515 19.1192 10.6971C18.9609 11.1427 18.9927 11.5608 19.1904 11.6311C19.388 11.7013 19.6766 11.397 19.8349 10.9514Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6685 14.1036L12.505 15.3427L12.6106 13.8389",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.271 0.487305L4.35381 7.61259L7.46374 10.8521L21.1218 18.9268C21.1218 18.9268 23.6856 20.1698 24.8963 19.1916C24.8963 19.1916 25.9615 18.4913 24.9459 17.1877C23.9302 15.8841 22.9631 14.8723 22.9631 14.8723L18.4401 12.3092L21.0688 6.97744C21.0688 6.97744 21.6048 5.4819 20.2309 4.59345L14.5319 10.1681L7.53859 6.22516L5.89474 1.42947L4.271 0.487305Z",
			fill: "#D9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.06396 4.84077L7.79372 3.72119L8.00266 3.95613C8.22027 4.20111 8.31002 4.53445 8.24453 4.85567L7.92123 6.4406L7.59794 6.28017L7.06396 4.84077Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.3813 19.4677L21.4696 15.69L4.35889 6.03662L4.38418 7.80798L4.57546 7.9206C4.50615 7.88109 4.4417 7.84402 4.38418 7.81006V7.83432L7.52287 11.0011L21.1227 18.9268C21.1227 18.9268 22.9859 19.8613 24.3816 19.4677H24.3813Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.97949 7.56982C3.99127 7.57745 4.13334 7.662 4.38387 7.80961V7.80753L3.97949 7.56982Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.40777 7.07861C4.40777 7.07861 1.5747 7.57586 0.703231 7.83331C0.703231 7.83331 0.68452 8.05993 0.687292 8.0582C0.69249 8.05542 0.822084 8.14656 1.00054 8.23249C1.67415 8.55648 2.63745 8.77755 3.15583 8.79245L6.65038 8.85725L6.68642 8.3413L4.40742 7.07861H4.40777Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8999 10.7354L0.608887 13.8522C0.608887 13.8522 1.64045 14.8304 2.84769 14.9552L16.8238 12.603L16.5438 11.1945L14.5355 11.164L12.8999 10.7354Z",
			fill: "#D9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.43218 6.72705C4.43218 6.72705 0.685715 7.84177 0.702694 7.83346C0.707892 7.83069 0.839566 7.89236 1.01802 7.9783C1.69163 8.30229 2.43282 8.46203 3.18024 8.44089L6.68623 8.34179L4.43184 6.7274L4.43218 6.72705Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9705 15.9255C15.5061 15.263 15.7473 14.5173 16.0689 13.6133L17.7352 14.4789C17.3468 15.2994 17.2536 16.1237 17.7352 16.955L15.9701 15.9252L15.9705 15.9255Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8254 17.0447L15.948 15.9494L15.9438 15.9435C15.4539 15.2446 15.7376 14.4465 16.0381 13.6018L16.0505 13.5664L17.7779 14.4635L17.7644 14.4919C17.3351 15.3984 17.3347 16.1985 17.7633 16.9379L17.825 17.0443L17.8254 17.0447ZM15.993 15.9005L17.65 16.8673C17.272 16.1451 17.2862 15.3669 17.6923 14.493L16.0869 13.6589C15.7498 14.6104 15.5658 15.2848 15.993 15.9005Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.1981 14.8025C2.1981 14.8025 2.8686 15.121 3.52489 15.1234L15.5155 13.4186C15.8787 13.3669 16.1593 13.0727 16.1933 12.7075L2.19775 14.8025H2.1981Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.2993 16.7658C22.2993 16.7658 23.4043 16.4574 23.8461 15.8521L25.0991 17.3795C25.0991 17.3795 25.2176 18.4668 23.8597 18.7943L22.2997 16.7658",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3828 15.7031C18.543 15.7031 18.6728 15.5059 18.6728 15.2627C18.6728 15.0194 18.543 14.8223 18.3828 14.8223C18.2226 14.8223 18.0928 15.0194 18.0928 15.2627C18.0928 15.5059 18.2226 15.7031 18.3828 15.7031Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6723 15.7558C19.6723 15.9991 19.5424 16.1963 19.3823 16.1963C19.2222 16.1963 19.0923 15.9991 19.0923 15.7558C19.0923 15.5126 19.2222 15.3154 19.3823 15.3154C19.5424 15.3154 19.6723 15.5126 19.6723 15.7558Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.396 11.2339C10.5562 11.2339 10.686 11.0367 10.686 10.7934C10.686 10.5502 10.5562 10.353 10.396 10.353C10.2358 10.353 10.106 10.5502 10.106 10.7934C10.106 11.0367 10.2358 11.2339 10.396 11.2339Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.19091 10.4873C9.35109 10.4873 9.48094 10.2901 9.48094 10.0469C9.48094 9.80363 9.35109 9.60645 9.19091 9.60645C9.03073 9.60645 8.90088 9.80363 8.90088 10.0469C8.90088 10.2901 9.03073 10.4873 9.19091 10.4873Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.98729 9.89597C8.14747 9.89597 8.27732 9.69879 8.27732 9.45555C8.27732 9.21232 8.14747 9.01514 7.98729 9.01514C7.82712 9.01514 7.69727 9.21232 7.69727 9.45555C7.69727 9.69879 7.82712 9.89597 7.98729 9.89597Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0572 15.5366L22.2898 16.7733L23.865 18.7938C22.1861 18.5007 20.8001 17.8849 19.9917 16.6326",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3335 14.842C13.4919 14.3964 13.3446 13.9372 13.0047 13.8165C12.6648 13.6957 12.2609 13.959 12.1026 14.4046C11.9443 14.8502 12.0915 15.3093 12.4314 15.4301C12.7713 15.5509 13.1752 15.2876 13.3335 14.842Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0046 18.1909L16.158 19.254L13.6968 17.833L15.5433 16.7373L18.0046 18.1909Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0035 18.1914L18.0031 19.1398L16.1562 20.2025L16.1569 19.2545L18.0035 18.1914Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1568 19.2545L16.1561 20.2026L13.6948 18.7815L13.6955 17.8335L16.1568 19.2545Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9574 17.9863L17.8697 17.9316L16.0166 17.9136L16.1046 17.985",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7982 17.8813L15.7979 18.0089L14.0293 19.0234L14.0296 18.8959L15.7982 17.8813Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7983 17.8179L18.0915 19.1419L16.2117 20.2202L13.9185 18.8962L15.7983 17.8179ZM16.212 20.1565L17.9809 19.1419L15.7986 17.882L14.0297 18.8966L16.212 20.1565Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0916 19.1421L18.0912 19.2696L16.2114 20.3479L16.2118 20.2204L18.0916 19.1421Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9189 18.9609L13.9185 19.0885L10.373 21.1623L10.3734 21.0348L13.9189 18.9609Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2126 20.2205L12.5569 22.3588L10.2637 21.0348L13.9194 18.8965L16.2126 20.2205ZM10.3742 21.0344L12.5565 22.2944L16.102 20.2205L13.9197 18.9606L10.3739 21.0344",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2127 20.2207L16.2123 20.3482L12.5566 22.4865L12.557 22.359L16.2127 20.2207Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5562 22.3592L12.5559 22.4867L10.2627 21.1623L10.263 21.0352L12.5562 22.3592Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.204 20.2272L16.1142 20.1714L10.2603 21.0346L10.35 21.1074",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0038 17.0885L16.2241 18.1312L13.7632 16.7101L15.5425 15.6675L18.0038 17.0885Z",
			fill: "#D9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0037 17.0884L18.003 17.2797L16.2236 18.3223L16.224 18.131L18.0037 17.0884Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2238 18.1315L16.2235 18.3228L13.7622 16.9017L13.7629 16.7104L16.2238 18.1315Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4583 18.4576L16.3685 18.4017L12.4619 22.3929L12.5513 22.4657",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1946 17.258L14.1048 17.2021L10.2665 21.0379L10.3562 21.111",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4709 18.456L11.9872 21.0615L9.47754 19.6123L13.9612 17.0068L16.4709 18.456Z",
			fill: "#F2FAFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4708 18.4561L16.4705 18.6508L11.9868 21.2566L11.9872 21.0615L16.4708 18.4561Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.987 21.062L11.9866 21.2571L9.47656 19.8079L9.47727 19.6128L11.987 21.062Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.58 17.359C17.5665 17.359 17.553 17.3517 17.5461 17.3393C17.5354 17.3206 17.5423 17.2967 17.561 17.2859L17.9768 17.051C17.9955 17.0402 18.0194 17.0472 18.0302 17.0659C18.0409 17.0846 18.034 17.1085 18.0153 17.1192L17.5995 17.3542C17.5932 17.3576 17.5866 17.3594 17.5804 17.3594L17.58 17.359Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.58 17.0515C17.5665 17.0515 17.553 17.0442 17.5461 17.0317C17.5354 17.013 17.5423 16.9891 17.561 16.9784L17.9768 16.7434C17.9955 16.7327 18.0194 16.7393 18.0302 16.7583C18.0409 16.777 18.034 16.801 18.0153 16.8117L17.5995 17.0466C17.5932 17.0501 17.5866 17.0518 17.5804 17.0518L17.58 17.0515Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.58 16.7444C17.5665 16.7444 17.553 16.7371 17.5461 16.7246C17.5354 16.7059 17.5423 16.682 17.561 16.6712L17.9768 16.4363C17.9955 16.4256 18.0194 16.4321 18.0302 16.4512C18.0409 16.4699 18.034 16.4938 18.0153 16.5046L17.5995 16.7395C17.5932 16.743 17.5866 16.7447 17.5804 16.7447L17.58 16.7444Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9962 17.1367C17.9747 17.1367 17.957 17.119 17.957 17.0976V16.4801C17.957 16.4586 17.9744 16.4409 17.9962 16.4409C18.018 16.4409 18.0353 16.4586 18.0353 16.4801V17.0976C18.0353 17.119 18.018 17.1367 17.9962 17.1367Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5274 17.3394H16.4868V17.9575H16.5274V17.3394Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5942 17.8532C16.8348 17.7124 17.3326 17.4234 17.4851 17.3346C17.5133 17.3182 17.5481 17.3182 17.5763 17.3343L18.2773 17.7093C18.3383 17.7439 18.2925 17.8298 18.2315 17.8641L17.3241 18.3781C17.2959 18.3942 17.2614 18.3939 17.2332 18.3778L16.5949 18.0084C16.5351 17.9738 16.5347 17.8882 16.5942 17.8532Z",
			fill: "#DA5850"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5444 16.7194V16.6865C17.5444 16.6896 17.5465 16.6924 17.5507 16.6948V16.7278C17.5465 16.7253 17.5444 16.7226 17.5444 16.7194Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2584 17.1035V17.1368L17.5508 16.7282V16.6953L18.2584 17.1035Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2895 17.1468V17.1797C18.2895 17.1642 18.2791 17.1482 18.2583 17.1364V17.1035C18.2791 17.1156 18.2895 17.1312 18.2895 17.1468Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3304 17.147V17.1799C18.3304 17.2014 18.3162 17.2229 18.2881 17.2391V17.2062C18.3165 17.1899 18.3304 17.1685 18.3304 17.147Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4868 17.3352V17.3022C16.4868 17.3054 16.4889 17.3081 16.4931 17.3106V17.3435C16.4889 17.3411 16.4868 17.3383 16.4868 17.3352Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2879 17.2061V17.239L17.4067 17.7511V17.7182L18.2879 17.2061Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1998 17.7186V17.7515L16.4922 17.343L16.4925 17.3101L17.1998 17.7186Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.287 17.0871C18.3442 17.12 18.3445 17.1733 18.2877 17.2063L17.4062 17.7184C17.3494 17.7513 17.2572 17.7513 17.2004 17.7184L16.4928 17.3099C16.4848 17.3054 16.4848 17.2977 16.4928 17.2932C16.5008 17.2887 16.5136 17.2887 16.5216 17.2932L17.2291 17.7018C17.2704 17.7257 17.3369 17.7257 17.3781 17.7018L18.2596 17.1896C18.3002 17.1657 18.3002 17.1273 18.259 17.1034L17.5514 16.6948C17.5434 16.6903 17.5434 16.6827 17.5514 16.6782C17.5594 16.6737 17.5722 16.6737 17.5801 16.6782L18.2877 17.0867L18.287 17.0871Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4069 17.7183V17.7512C17.35 17.7841 17.2579 17.7841 17.2007 17.7512V17.7183C17.2579 17.7512 17.35 17.7512 17.4069 17.7183Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5449 17.0275V16.9946C17.5449 16.9977 17.547 17.0009 17.5512 17.0029V17.0359C17.547 17.0334 17.5449 17.0303 17.5449 17.0275Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2588 17.4106L18.2585 17.4439L17.5513 17.0354V17.0024L18.2588 17.4106Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2901 17.4549V17.4879C18.2901 17.4723 18.2797 17.4563 18.2593 17.4445V17.4116C18.2801 17.4237 18.2901 17.4393 18.2901 17.4549Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3304 17.4551V17.488C18.3304 17.5095 18.3162 17.531 18.2881 17.5472V17.5143C18.3165 17.498 18.3304 17.4766 18.3304 17.4551Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4868 17.6428V17.6099C16.4868 17.613 16.4889 17.6158 16.4931 17.6182V17.6511C16.4889 17.6487 16.4868 17.6459 16.4868 17.6428Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2879 17.5137V17.5469L17.4067 18.0587V18.0258L18.2879 17.5137Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1998 18.0264V18.0596L16.4922 17.6511L16.4925 17.6182L17.1998 18.0264Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.287 17.3947C18.3442 17.4276 18.3445 17.481 18.2877 17.5139L17.4065 18.026C17.3497 18.0589 17.2575 18.0589 17.2004 18.026L16.4928 17.6175C16.4848 17.613 16.4848 17.6054 16.4928 17.6009C16.5008 17.5964 16.5136 17.5964 16.5216 17.6009L17.2291 18.0094C17.2704 18.033 17.3369 18.0333 17.3781 18.0094L18.2593 17.4972C18.2998 17.4733 18.2998 17.4349 18.259 17.411L17.5514 17.0024C17.5434 16.9979 17.5434 16.9903 17.5514 16.9858C17.5594 16.9813 17.5722 16.9813 17.5801 16.9858L18.2877 17.3943L18.287 17.3947Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4069 18.0259V18.0588C17.3497 18.0917 17.2575 18.0917 17.2007 18.0588V18.0259C17.2579 18.0588 17.35 18.0588 17.4069 18.0259Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5444 17.3342V17.3013C17.5444 17.3044 17.5465 17.3072 17.5507 17.3096V17.3425C17.5465 17.3401 17.5444 17.3373 17.5444 17.3342Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2584 17.7176V17.7505L17.5508 17.342L17.5511 17.3091L18.2584 17.7176Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2895 17.7609V17.7939C18.2895 17.7783 18.2791 17.7623 18.2583 17.7502V17.7173C18.2791 17.7294 18.2895 17.745 18.2895 17.7609Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3307 17.7607V17.7937C18.3307 17.8151 18.3165 17.8366 18.2881 17.8529V17.82C18.3165 17.8037 18.3307 17.7822 18.3307 17.7607Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4868 17.9484V17.9155C16.4868 17.9186 16.4889 17.9214 16.4927 17.9238V17.9568C16.4885 17.9543 16.4868 17.9516 16.4868 17.9484Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2879 17.8208V17.8541L17.4067 18.3662V18.3329L18.2879 17.8208Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1998 18.3324V18.3653L16.4922 17.9567V17.9238L17.1998 18.3324Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2872 17.701C18.3444 17.7339 18.3444 17.7876 18.2876 17.8205L17.4064 18.3327C17.3496 18.3656 17.2574 18.3656 17.2002 18.3327L16.4927 17.9241C16.4847 17.9196 16.485 17.912 16.4927 17.9075C16.5003 17.903 16.5135 17.903 16.5214 17.9075L17.229 18.316C17.2702 18.3396 17.3368 18.3399 17.378 18.316L18.2592 17.8039C18.3001 17.78 18.2997 17.7415 18.2588 17.7176L17.5513 17.3091C17.5433 17.3046 17.5433 17.2969 17.5513 17.2924C17.5592 17.2879 17.572 17.2879 17.58 17.2924L18.2876 17.701H18.2872Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4069 18.3325V18.3654C17.35 18.3984 17.2575 18.3984 17.2007 18.3654V18.3325C17.2579 18.3654 17.3504 18.3654 17.4069 18.3325Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3291 17.7373H17.2886V18.369H17.3291V17.7373Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.332 17.1655H18.2915V17.7972H18.332V17.1655Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5816 16.6865H17.541V17.3182H17.5816V16.6865Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1954 18.1554C16.1815 18.1554 16.1684 18.1481 16.1611 18.1349C16.1507 18.1159 16.1576 18.0923 16.1767 18.0819L16.4923 17.9086C16.5111 17.8982 16.535 17.9052 16.5454 17.9242C16.5558 17.9433 16.5488 17.9669 16.5298 17.9772L16.2141 18.1505C16.2082 18.1536 16.2016 18.1554 16.1954 18.1554Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1954 17.8477C16.1815 17.8477 16.1684 17.8405 16.1611 17.8273C16.1507 17.8082 16.1576 17.7847 16.1767 17.7743L16.4923 17.601C16.5111 17.5906 16.535 17.5976 16.5454 17.6166C16.5558 17.6357 16.5488 17.6592 16.5298 17.6696L16.2141 17.8429C16.2082 17.846 16.2016 17.8477 16.1954 17.8477Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1954 17.5406C16.1815 17.5406 16.1684 17.5333 16.1611 17.5202C16.1507 17.5011 16.1576 17.4775 16.1767 17.4671L16.4923 17.2939C16.5111 17.2835 16.535 17.2904 16.5454 17.3095C16.5558 17.3285 16.5488 17.3521 16.5298 17.3625L16.2141 17.5358C16.2082 17.5389 16.2016 17.5406 16.1954 17.5406Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1959 18.1553C16.1744 18.1553 16.1567 18.1376 16.1567 18.1161V17.4986C16.1567 17.4771 16.1741 17.4595 16.1959 17.4595C16.2177 17.4595 16.235 17.4771 16.235 17.4986V18.1161C16.235 18.1376 16.2177 18.1553 16.1959 18.1553Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7638 16.7491C13.7503 16.7491 13.7371 16.7422 13.7299 16.7297C13.7191 16.711 13.7254 16.6871 13.7441 16.6763L15.5307 15.6337C15.5494 15.6229 15.5733 15.6292 15.584 15.6479C15.5948 15.6666 15.5885 15.6905 15.5698 15.7012L13.7832 16.7439C13.777 16.7474 13.7704 16.7491 13.7635 16.7491H13.7638Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7638 16.442C13.7503 16.442 13.7371 16.435 13.7299 16.4225C13.7191 16.4038 13.7254 16.3799 13.7441 16.3692L15.5307 15.3265C15.5494 15.3158 15.5733 15.322 15.584 15.3407C15.5948 15.3595 15.5885 15.3834 15.5698 15.3941L13.7832 16.4368C13.777 16.4402 13.7704 16.442 13.7635 16.442H13.7638Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7638 16.1353C13.7503 16.1353 13.7371 16.1284 13.7299 16.1159C13.7191 16.0972 13.7254 16.0733 13.7441 16.0625L15.5307 15.0199C15.5494 15.0092 15.5733 15.0154 15.584 15.0341C15.5948 15.0528 15.5885 15.0767 15.5698 15.0875L13.7832 16.1301C13.777 16.1336 13.7704 16.1353 13.7635 16.1353H13.7638Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.7638 16.0552C13.7854 16.0552 13.8029 16.0727 13.8029 16.0943V16.7118C13.8029 16.7334 13.7854 16.751 13.7638 16.751C13.7421 16.751 13.7246 16.7334 13.7246 16.7118V16.0943C13.7246 16.0727 13.7421 16.0552 13.7638 16.0552Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.2101 15.7939C14.2317 15.7939 14.2492 15.8115 14.2492 15.8331V16.4506C14.2492 16.4722 14.2317 16.4897 14.2101 16.4897C14.1884 16.4897 14.1709 16.4722 14.1709 16.4506V15.8331C14.1709 15.8115 14.1884 15.7939 14.2101 15.7939Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.6573 15.5332C14.6789 15.5332 14.6965 15.5507 14.6965 15.5724V16.1898C14.6965 16.2115 14.6789 16.229 14.6573 16.229C14.6357 16.229 14.6182 16.2115 14.6182 16.1898V15.5724C14.6182 15.5507 14.6357 15.5332 14.6573 15.5332Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.1036 15.2729C15.1252 15.2729 15.1428 15.2905 15.1428 15.3121V15.9296C15.1428 15.9512 15.1252 15.9687 15.1036 15.9687C15.082 15.9687 15.0645 15.9512 15.0645 15.9296V15.3121C15.0645 15.2905 15.082 15.2729 15.1036 15.2729Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.5514 15.0117C15.573 15.0117 15.5905 15.0292 15.5905 15.0509V15.6684C15.5905 15.69 15.573 15.7075 15.5514 15.7075C15.5297 15.7075 15.5122 15.69 15.5122 15.6684V15.0509C15.5122 15.0292 15.5297 15.0117 15.5514 15.0117Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4741 19.5703C17.5282 19.351 17.4554 19.1445 17.3116 19.1091C17.1678 19.0736 17.0074 19.2226 16.9533 19.4419C16.8993 19.6611 16.9721 19.8676 17.1159 19.9031C17.2597 19.9385 17.4201 19.7895 17.4741 19.5703Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3045 19.5237C17.3231 19.4483 17.2981 19.3773 17.2486 19.3651C17.1992 19.3529 17.1441 19.4042 17.1255 19.4796C17.1069 19.5551 17.1319 19.6261 17.1813 19.6383C17.2307 19.6505 17.2859 19.5992 17.3045 19.5237Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4642 22.0165C13.4919 21.9044 13.4548 21.7989 13.3814 21.7808C13.308 21.7627 13.2261 21.8389 13.1985 21.9509C13.1708 22.063 13.2079 22.1685 13.2813 22.1866C13.3547 22.2047 13.4366 22.1285 13.4642 22.0165Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3782 21.9925C13.3877 21.954 13.3749 21.9178 13.3496 21.9115C13.3244 21.9053 13.2962 21.9314 13.2867 21.9699C13.2772 22.0084 13.29 22.0446 13.3153 22.0508C13.3406 22.0571 13.3687 22.0309 13.3782 21.9925Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8641 16.9312L10.8574 19.3048L12.4035 20.1204V17.8199L10.8641 16.9312Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4038 20.1203L13.7989 19.2786L14.1785 18.2103L14.1834 16.835L12.4038 17.8198V20.1203Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4036 17.8199L10.8643 16.9312L12.6442 15.9463L14.1832 16.835L12.4036 17.8199Z",
			fill: "#D9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.832 14.3377L13.8861 14.5199L15.5622 15.4791C16.0022 14.7555 16.8176 14.5483 17.768 14.5265L17.8306 14.4393C17.8306 14.4393 16.1325 13.6353 16.0414 13.6377C15.9502 13.6401 13.832 14.3377 13.832 14.3377Z",
			fill: "#D9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.832 14.3377C14.2953 13.6745 15.1006 13.5535 16.0601 13.5459L17.8349 14.4389C16.9309 14.355 16.1245 14.5497 15.5088 15.2875L13.8324 14.3373L13.832 14.3377Z",
			fill: "white"
		})
	]
});
export default SvgPlane;
